<template>
  <tr class="ignored bg-orange-200/30 text-sm child:py-2 first-child:pl-3 last-child:pr-3">
    <td
      :colspan="9 + (showPercentages ? 3 : 0) + (showForecasts ? 1 : 0) + (ratesColumn ? 1 : 0)"
      class="text-left"
    >
      <AppInput
        v-model="description"
        name="category_description"
        type="text"
        class="w-full max-w-md form-input h-8"
        placeholder="Category description"
        @blur="trySave"
        @keyup.enter="$event.target.blur()"
      />
    </td>

    <td class="text-right w-10">
      <button
        type="button"
        class="btn-icon btn-icon-red"
        title="Remove row"
        @click="emit('removed')"
      >
        <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
      </button>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { useScopeGapCategoriesStore } from '@/store/scopeGapCategories';
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{
    projectId: string;
    packageId: string;
    canEdit: boolean;
    showPercentages?: boolean;
    showForecasts?: boolean;
    ratesColumn?: boolean;
  }>(),
  {
    showPercentages: false,
    showForecasts: false,
    ratesColumn: false,
  },
);

const emit = defineEmits<{
  (e: 'saved'): void;
  (e: 'removed'): void;
}>();

const scopeGapCategoriesStore = useScopeGapCategoriesStore();
const storeCategoryAction = useStoreApiAction(scopeGapCategoriesStore.store);
const description = ref('');
const saving = ref(false);

function trySave() {
  if(!props.canEdit || saving.value || !description.value.trim()) return;

  saving.value = true;

  storeCategoryAction.request(props.projectId, props.packageId, {
    description: description.value.trim(),
  }).then((data) => {
    emit('saved');
  }).catch(() => {
    saving.value = false;
  });
}
</script>
